import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { GetApprovedConsultants, UpdateCandidateClientStatus } from '../apiconstants/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import NoDataImage from '../assets/images/Nodata.jpg'
import LoadingSpinner from '../helpers/loadingspinner'
import defaultImage from '../assets/images/icons8-circled-user-male-skin-type-3-100.png'
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 20) + "...";
}
const Viewcandidatedetailsbycandidateguid = () => {
  let query = useQuery();
  const clientGuid = query.get("client");
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const [showIcon, setShowIcon] = useState('list');
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", url: "" });
  const [showDropdownModal, setShowDropdownModal] = useState(false);
  const [comments, setComments] = useState(""); // End date state
  const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined"||value === "null..." || value === "undefined...") 
    ? "" 
    : value;

  const itemsPerPage = 25;
  const [selectedUserGuid, setSelectedUserGuid] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const handleModalOpen = (guid,clientStatus,comments) => {
    console.log("49",)
    setSelectedUserGuid(guid);
    setShowDropdownModal(true);
    setComments(comments);
    setSelectedStatus(clientStatus);
  };

  const handleModalClose = () => {
    setShowDropdownModal(false);
  };

  const GetCandidatesList = () => {
    setIsLoading(true); // Start loading
    axios.get(`${GetApprovedConsultants.APIURL}?vendorGuid=${clientGuid}`)
      .then(response => {
        console.log(response.data); // Log the response data for inspection
        if(response.data.message == 'No approved consultants found.'){
          setUsers([]);
        }  else{
            setUsers(response.data);
          }
       
        // assuming the data is an array of roles
        setIsLoading(false); // Stop loading
      })
      .catch(error => {
        console.error('Error fetching users:', error);
        setIsLoading(false); // Stop loading in case of error
      });
  }
  const handleStatusChange = () => {
    console.log(selectedStatus)
    if(selectedStatus == null){
      Swal.fire("You can not submit without selecting any option!")
      return
    }
    setIsLoading(true)
      const payload ={
  "guid": selectedUserGuid,
  "status": selectedStatus,
  "comments": comments
      }
    axios.post(`${UpdateCandidateClientStatus.APIURL}`,payload)
      .then((result) => {
        setIsLoading(false)
        if (result.data == 'Status updated successfully') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Updated Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
          GetCandidatesList();
          setShowDropdownModal(false);
        }
      }
      )
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };
  const renderAttachment = (fileUrl) => {
    if (fileUrl) {
      const fileExtension = fileUrl.split('.').pop().toLowerCase();
      if (fileExtension === 'pdf') {
        return (
          <iframe src={fileUrl} title="Attachment" style={{ width: '100%', height: '500px' }} />
        );
      } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
        return (
          <img src={fileUrl} alt="Attachment" style={{ width: '100%' }} />
        );
      } else if (fileExtension === 'docx') {
        return (
          <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`} title="Attachment" style={{ width: '100%', height: '500px' }} />
        );
      }
      
 else if (['html', 'htm'].includes(fileExtension)) {
            return (
                <iframe
                    src={fileUrl}
                    title="HTML Attachment"
                    style={{ width: '100%', height: '500px', border: 'none' }}
                />
            );
        }  else {
        return (
          <a href={fileUrl} target="_blank" rel="noopener noreferrer">Download Attachment</a>
        );
      }
    }
    return <p>No attachment available</p>;
  };

  const handleShowModal = (title, url) => {
    setModalContent({ title, url });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    GetCandidatesList();
  }, []);

  const filteredUsers = users?.filter(role =>
    role.consultantName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    role.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    role.jobRole?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    role.clientStatus?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const offset = currentPage * itemsPerPage;
  const currentUsers = filteredUsers.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredUsers.length / itemsPerPage);

  return (
  
      <div className='container-fluid mt-5 ml-3 mr-3'>
      
        <div className="row">
          <div className="card" style={{ borderRadius: '5px', border: 'none', boxShadow: '0px 6px 24px 0px rgba(53, 55, 81, 0.06)' }}>
            <div className="card-header d-flex flex-column flex-sm-row justify-content-between pt-3 pb-3" style={{ backgroundColor: '#fff', borderBottom: '1px solid #e6e6e6' }}>
              <h2 className="card-title mt-2 mr-2" style={{ color: "#00a7ac" }}>Candidates List</h2>
              <div className='d-flex'>
                <input
                  type="text"
                  className="form-control mr-3"
                  placeholder="Search by Full Name or Email or Job Role or Status"
                  style={{ width: 300 }}
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(0);
                  }}
                />
                {showIcon === 'grid' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                    <button
                      className="btn btn-primary mr-3"
                      onClick={() => handleViewToggle('list')}
                      style={{ backgroundColor: "#00a7ac" }}
                    >
                      <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
                    </button>
                  </OverlayTrigger>
                )}
                {showIcon === 'list' && (
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                    <button
                      className="btn btn-primary mr-3"
                      onClick={() => handleViewToggle('grid')}
                      style={{ backgroundColor: "#00a7ac" }}
                    >
                      <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
                    </button>
                  </OverlayTrigger>
                )}

              </div>
            </div>
              
            {/* <div className="card-body"> */}
              {isLoading ? (
                <LoadingSpinner />
              ) : filteredUsers.length === 0 ? (
                <div className="pb-5 text-center">
      <img
        title="No Data"
        className="no-data-img"
        alt="no-data-img"
        src={NoDataImage}
        style={{ height: 370 }}
      />
    </div>
              ) : (
                <>
                  {viewType === 'grid' ? (
                    <div className="d-flex flex-wrap mt-3">
                      {currentUsers?.map((user, index) => (
                        <div key={index} className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3">
                          <div className="card" style={{ background: "#f8f8f8", border: "1px solid #00a7ac26", borderRadius: 20, height: 620 }}>
                            <div className='card-header' style={{ background: "none", minHeight: 140 }}>
                              <div className='row'>
                                <div className='col-4'>
                                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Pic</Tooltip>)}>
                                    <img alt="Profile Photo" src={(user?.photo === "null") || (user.photo === null) ? defaultImage : user?.photoURL} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} />
                                  </OverlayTrigger>
                                </div>
                                <div className='col-8'>
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Full Name</Tooltip>}>
                                    <h5 className="text-center mt-3" style={{ color: "#00a7ac", fontSize: 20 }}>
                                      {user.consultantName}
                                    </h5>
                                  </OverlayTrigger>
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Job Title</Tooltip>}>
                                    <h5 className="text-center mt-3" style={{ color: "#00a7ac", fontSize: 20 }}>
                                      {user.jobTitle}
                                    </h5>
                                  </OverlayTrigger>
                                </div>
                              </div>
                            </div>
                            <div className="card-body p-2">
                              <div style={{ minHeight: 200 }}>

                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Email</Tooltip>}>
                                  <p className="itemstext mt-3" style={{ fontSize: 14 }}>
                                    <i className="fas fa-envelope" style={{ color: "#00a7ac", marginRight: 10 }}></i>
                                    {user.email}
                                  </p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Mobile Number</Tooltip>}>
                                  <p className="itemstext mt-3" style={{ fontSize: 14 }}>
                                    <i className="fas fa-phone" style={{ color: "#00a7ac", marginRight: 10 }}></i>
                                    {user.mobileNumber}
                                  </p>
                                </OverlayTrigger>
                                {/* <OverlayTrigger placement="bottom" overlay={<Tooltip>Education</Tooltip>}>
                                  <p className="itemstext mt-3" style={{ fontSize: 14 }}>
                                    <i className="fas fa-graduation-cap" style={{ color: "#00a7ac", marginRight: 10 }}></i>
                                    {user.education}
                                  </p>
                                </OverlayTrigger> */}
                                {user.linkedInUrl !== null && user.linkedInUrl !== "null" && (<OverlayTrigger placement="bottom" overlay={<Tooltip>LinkedIn URL</Tooltip>}>
                                  <p className="itemstext mt-3" style={{ fontSize: 14 }}>
                                    <i className="fab fa-linkedin" style={{ color: "#00a7ac", marginRight: 10 }}></i>
                                    <a href={user.linkedInUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#00a7ac" }}>
                                      {user.linkedInUrl}
                                    </a>
                                  </p>
                                </OverlayTrigger>
                                )}
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Total Experience</Tooltip>}>
                                  <p className="itemstext mt-3" style={{ fontSize: 14 }}>
                                    <i className="fas fa-briefcase" style={{ color: "#00a7ac", marginRight: 10 }}></i>
                                    {user.experience} years
                                  </p>
                                </OverlayTrigger>
                                {/* <OverlayTrigger placement="bottom" overlay={<Tooltip>Availability</Tooltip>}>
                                  <p className="itemstext mt-3" style={{ fontSize: 14 }}>
                                    <i className="fas fa-calendar-check" style={{ color: "#00a7ac", marginRight: 10 }}></i>
                                    IMMEDIATE
                                  </p>
                                </OverlayTrigger> */}
                                {/* <OverlayTrigger placement="bottom" overlay={<Tooltip>Bill Rate</Tooltip>}>
                                  <p className="itemstext mt-3" style={{ fontSize: 14 }}>
                                    <i className="fas fa-dollar-sign" style={{ color: "#00a7ac", marginRight: 10 }}></i>
                                  { safeValue(user.billRate) }
                                  </p>
                                </OverlayTrigger> */}
                                {/* <OverlayTrigger placement="bottom" overlay={<Tooltip>Work Mode</Tooltip>}>
                                  <p className="itemstext mt-3" style={{ fontSize: 14 }}>
                                    <i className="fas fa-map-marker-alt" style={{ color: "#00a7ac", marginRight: 10 }}></i>
                                    {user.workMode}
                                  </p>
                                </OverlayTrigger> */}
                                <div className="d-flex align-items-center">
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Status</Tooltip>}>
                                    <p className="itemstext" style={{ fontSize: 14 }} >
                                      <i className="fas fa-hourglass-half" style={{ color: "#00a7ac", marginRight: 10 }}  ></i>
                                      {user.clientStatus}
                                    </p>
                                  </OverlayTrigger>
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit Status</Tooltip>}>
                                    <FontAwesomeIcon icon="fas fa-edit" onClick={() => handleModalOpen(user.guid,user.clientStatus,user.comments)} style={{ marginLeft: 10, marginTop: -14, color: "#00a7ac", fontSize: 14 }} />
                                  </OverlayTrigger>
                                  
                                </div>
   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> <span
          dangerouslySetInnerHTML={{
            __html: safeValue(user.comments)
          }}
        /></Tooltip>)}>
                                    <p className="itemstext" style={{ fontSize: 14 }} >
                                      <i className="fa fa-code" style={{ color: "#00a7ac", marginRight: 10 }}  ></i>
  <span
        dangerouslySetInnerHTML={{
          __html: safeValue(substring_str(user.comments))
        }}
      />                                    </p>
                                  </OverlayTrigger>
                                {user.resume !== null && user.resume !== "null" && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume</Tooltip>}>
                                    <p className="text-para">
                                      <a
                                        href="#"
                                        style={{ fontSize: 14 }}
                                        onClick={() => handleShowModal('Resume', user.fileUrl)}
                                      >
                                        <i className="fa fa-file-alt icons"></i> View Resume
                                      </a>
                                      &nbsp;|&nbsp;
                                      <a
                                        href={user.fileUrl}
                                        style={{ fontSize: 14 }}
                                        download
                                        target="_blank"
                                      >
                                        <i className="fa fa-download icons"></i> Download Resume
                                      </a>
                                    </p>
                                  </OverlayTrigger>
                                )}

                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                   <div className="col-12 mt-3" style={{ overflowX: "auto", width: "100%" }}>
                      <table className="table" style={{ minWidth: "100%", fontSize: 14 }}>
                        <thead>
                          <tr>
                            <th>Full Name</th>
                            <th>Job Title</th>
                            <th>Email</th>
                            <th>Mobile Number</th>
                            {/* <th>Education</th> */}
                            <th>LinkedIn URL</th>
                            <th>Total Experience</th>
                            {/* <th>Availability</th> */}
                            {/* <th>Bill Rate</th> */}
                            {/* <th>Work Mode</th> */}
                            <th>Status</th>
                            <th>Comments</th>
                            <th>Resume</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentUsers?.map((user, index) => (
                            <tr key={index}>
                              <td>{user.consultantName}</td>
                              <td>{user.jobTitle}</td>
                            <td style={{ maxWidth: 200, wordWrap: "break-word", wordBreak: "break-word", overflowWrap: "break-word" }}>{user.email}</td>

                           
                              <td>{user.mobileNumber}</td>
                              {/* <td>{user.education}</td> */}
                              <td style={{ maxWidth: 200, wordWrap: "break-word", wordBreak: "break-word", overflowWrap: "break-word" }}>
                                <a
                                  href={user.linkedInUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#00a7ac" }}
                                >
                                  {user.linkedInUrl}
                                </a>
                              </td>

                              <td>{safeValue(user.experience)} years</td>
                              {/* <td>IMMEDIATE</td> */}
                              {/* <td>{safeValue(user.billRate)}</td> */}
                              {/* <td>{user.workMode}</td> */}
                              <td >
                                {user.clientStatus}  <FontAwesomeIcon icon="fas fa-edit" onClick={() =>  handleModalOpen(user.guid,user.clientStatus,user.comments)} style={{ marginLeft: 4,  color: "#00a7ac", fontSize: 14 }} />
                              </td>
                               <OverlayTrigger
                                        placement="bottom"
                                        overlay={(props) => (
                                          <Tooltip id="tooltip" {...props}>
                                         <span  dangerouslySetInnerHTML={{ __html: safeValue(user.comments) }}></span>
                                          </Tooltip>
                                        )}
                                      >
     <td dangerouslySetInnerHTML={{ __html: safeValue(substring_str(user.comments)) }}></td>
                                         </OverlayTrigger>
                              <td>
                                {user.resume && user.resume !== "null" && (
                                  <>
                                    <a
                                      href="#"
                                      onClick={() => handleShowModal('Resume', user.fileUrl)}
                                      style={{ fontSize: 14 }}
                                    >
                                      <i className="fa fa-eye icons"></i>
                                    </a>
                                    &nbsp;|&nbsp;
                                    <a
                                      href={user.fileUrl}
                                      download
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ fontSize: 14 }}
                                    >
                                      <i className="fa fa-download icons"></i> Resume
                                    </a>
                                  </>
                                )}
                              </td>

                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                  )}
                </>
              )}
            </div>
          {/* </div> */}
        </div>
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{modalContent.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {renderAttachment(modalContent.url)}
          </Modal.Body>
        </Modal>
        {filteredUsers.length > itemsPerPage && (


          <div className="d-flex justify-content-center mt-3">
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={pageCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              activeClassName={'active'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
            />
          </div>

        )}
        <Modal show={showDropdownModal} onHide={handleModalClose} dialogClassName="custom-inline-width">
          <Modal.Header closeButton>
            <Modal.Title style={{fontSize:20}}>Update Candidate Status</Modal.Title>
          </Modal.Header>
                <Modal.Body style={{width:700}}>
                  {["New","Submitted","In-Progress", "Interview Scheduled","On Hold","Selected","Rejected" ].map((status) => (
              <Button
              key={status}
               size="sm"
              variant={selectedStatus === status ? "primary" : "outline-primary"} 
              className="w-100 mb-2"
              onClick={() => setSelectedStatus(status)}
            >
              {status}
            </Button>
            
            ))}
              <ReactQuill
                value={comments}
                onChange={setComments}
                placeholder="Comments"
                style={{height:180, marginBottom: 20}}
              />
             {/* <textarea type="text" style={{height:100}} title='' placeholder='Comments'
            onChange={(e)=>setComments(e.target.value)} 
           value =  {safeValue(comments)}
           className={`form-control basic-form mt-3 `} ></textarea> */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => handleStatusChange()}>
              Submit
            </Button>
            <Button variant="secondary" onClick={handleModalClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
          <style>
{`
  .custom-inline-width {
    max-width: 700px !important;
    width: 100%;
  }
`}
</style>
      </div>
  
  );
};

export default Viewcandidatedetailsbycandidateguid;
